export default class EventUtil {
  /**
   * 事件监听实例化
   * @param domObj DOM树对象
   * @default window
   */
  constructor(domObj = window) {
    this.domObj = domObj;
  }

  /**
   * 元素对象
   */
  domObj;

  /**
   * 元素对象池
   */
  domObjPool = {};

  /**
   * 类型
   */
  _eventType;

  /**
   * 事件回调
   */
  _listenerCallBack

  /**
   * 添加事件监听
   * @param _eventType 类型
   * @param _listenerCallBack 监听回调函数
   */
  add(_eventType, _listenerCallBack){
    this._eventType = _eventType;
    this._listenerCallBack = _listenerCallBack;

    if (this.domObj.addEventListener){
      const id = this.getId();

      // 如果回调为空，添加默认方法
      if (!this._listenerCallBack) {
        this._listenerCallBack = () => {};
      }

      // 监听事件
      this.domObj.addEventListener(this._eventType, this._listenerCallBack, false);

      // 存入对象池
      this.domObjPool[id] = {
        eventType: this._eventType,
        dom: this.domObj,
        listener: this._listenerCallBack,
      };

      return id;
    } else {
      return null;
    }
  }

  /**
   * 监听事件ID
   * @returns 监听事件ID
   */
  getId() {
    return String(Object.values(this.domObjPool).length + 1);
  }

  /**
   * 移除事件监听
   */
  remove(id = this.getId()) {
    if (id) {
      const item = this.domObjPool[id];
      item.dom.removeEventListener(item.eventType, item.listener, false);

      delete this.domObjPool[id];
    }
  }

  /**
   * 销毁对象池中所有事件监听
   */
  disposed() {
    for (const key in this.domObjPool) {
      if (this.domObjPool[key]) {
        this.remove(key);
      }
    }
  }
}
